import {
  HIDE_MEDIA_BUYER_BUDGETS_LOADER,
  SET_ERROR_MEDIA_BUYER_BUDGETS,
  SET_MEDIA_BUYER_BUDGETS,
  SET_MEDIA_BUYER_BUDGET_FOR_ID,
  SET_MEDIA_BUYER_DATA_FOR_ADD,
  SHOW_MEDIA_BUYER_BUDGETS_LOADER,
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  client_budget: null,
  dataForAddBudget: null,
  isError: false,
  loading: false,
  error: null,
};

const MediaBuyerBudgets = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_MEDIA_BUYER_BUDGETS:
      return {
        ...state,
        data: action.payload,
      };
    case SET_MEDIA_BUYER_DATA_FOR_ADD:
      return {
        ...state,
        dataForAddBudget: action.payload,
      };
    case SET_MEDIA_BUYER_BUDGET_FOR_ID:
      return {
        ...state,
        client_budget: action.payload,
      };
    case SHOW_MEDIA_BUYER_BUDGETS_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_MEDIA_BUYER_BUDGETS_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR_MEDIA_BUYER_BUDGETS:
      return {
        ...state,
        isError: action.payload,
      };
    default:
      return state;
  }
};

export default MediaBuyerBudgets;
